(ns common.schema.entities.kpi-member
  (:require [common.schema.schema-utils :as su]
            [common.currencies :as currencies]
            [common.kpis :as kpis]))

(def status-options [{:key   :kpi-member.status/active
                      :label "Active"}
                     {:key   :kpi-member.status/paused
                      :label "Paused"}])



(def schema
  (vec (concat (su/single-ref-field :kpi-member/account "Account" [:entity.type/account] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-member/asset "Asset" [:entity.type/company] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-member/person "Contact" [:entity.type/person] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-member/target "KPI Category" [:entity.type/kpi-category] {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-member/status "Status" status-options {:authorization su/access-user-ssg})
               )))
